module.exports = __webpack_public_path__ + "09e70abbf7f3c8e0a712186b7840f08d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/close_icn.svg
// module id = K5bs
// module chunks = 1